import React from 'react';
import type { IconProps } from './IconPlus';

export const IconKeyboard: React.FC<IconProps> = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect x="2.5" y="5" width="15" height="10" rx="2" stroke={color} strokeWidth="1.5"/>
    <path d="M5.5 8H6.5M8 8H9M10.5 8H11.5M13 8H14M5 10.5H7M8.5 10.5H11.5M13 10.5H15" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

